import React from 'react';

import Markup from '../../../../markup';
import {SaveButtons} from "../SaveButtons";


function MobileSubmit() {

  return (
    <>
      <Markup.Screen.Name.Wrapper>
        <SaveButtons/>
      </Markup.Screen.Name.Wrapper>
    </>
  );
}

export default React.memo(MobileSubmit);
